import XD from "../../../assets/images/adobe-xd.png";
import PS from "../../../assets/images/adobe-photoshop.png";
import AI from "../../../assets/images/adobe-illustrator.png";
import CSS from "../../../assets/images/css.png";
import GSAP from "../../../assets/images/gsap.png";
import GULP from "../../../assets/images/gulp.png";
import HTML from "../../../assets/images/html.png";
import JS from "../../../assets/images/javascript.png";
import NODE from "../../../assets/images/nodejs.png";
import REACT from "../../../assets/images/react.png";
import WP from "../../../assets/images/wordpress.png";
import PHP from "../../../assets/images/php.png";

const icons = [
  { img: WP, color: "#01579B" },
  { img: HTML, color: "#E44D26" },
  { img: CSS, color: "#264DE4" },
  { img: PHP, color: "#6181B6" },
  { img: JS, color: "#F7DF1E" },
  { img: GSAP, color: "#8AC640" },
  { img: GULP, color: "#D34A47" },
  { img: XD, color: "#2E001E" },
  { img: PS, color: "#31C5F0" },
  { img: AI, color: "#FF7F18" },
  { img: NODE, color: "#83CD29" },
  { img: REACT, color: "#61DBFB" },
];

export default icons;
